import { AIAssessmentEvaluationSubmission, buildHumanAssessedSubmissions } from "./evaluation";

import { useCapabilities } from "store/capability-hooks";
import { isAssessmentAIEvaluationEnabled } from "utils/waffle-flags";

export const useAIAssessmentEvaluationAvailability = (
  submissions: AIAssessmentEvaluationSubmission[],
) => {
  const { canAuthorSection } = useCapabilities();
  const humanAssessedSubmissions = buildHumanAssessedSubmissions({ submissions });
  return {
    humanAssessedSubmissions,
    shouldShowEvaluationButton:
      canAuthorSection && isAssessmentAIEvaluationEnabled() && humanAssessedSubmissions.length > 0,
  };
};
